import React from "react";
import styled from "styled-components";

interface DeleteIconButtonProps {
  onRemove: () => void;
  largeIcon?: boolean;
  blackBackground?: boolean;
}

const IconContainer = styled.div<{
  $largeIcon?: boolean;
  $blackBackground?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $largeIcon }) => ($largeIcon ? "24px" : "20px")};
  height: ${({ $largeIcon }) => ($largeIcon ? "24px" : "20px")};
  background-color: ${({ $blackBackground }) =>
    $blackBackground ? "#333333" : "var(--red-600)"};
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background-color: ${({ $blackBackground }) =>
      $blackBackground ? "#505050" : "var(--red-500)"};
  }

  &:focus {
    border: 1px solid var(--red-600);
  }

  i {
    color: white;
    font-size: ${({ $largeIcon }) => ($largeIcon ? "14px" : "8px")};
  }
`;

const DeleteIconButton: React.FC<DeleteIconButtonProps> = ({
  onRemove,
  largeIcon,
  blackBackground,
}: DeleteIconButtonProps) => {
  return (
    <IconContainer
      $largeIcon={largeIcon}
      $blackBackground={blackBackground}
      onClick={onRemove}
      role="button"
      tabIndex={0}
    >
      <i className="pi pi-times" />
    </IconContainer>
  );
};

export default DeleteIconButton;
